
import React from "react";
import { renderHTML } from "../utils";

interface ProductInfoProps {
  logo?: string;
  productName: string;
  planName: string;
  description: string | null;
}

export function ProductInfo({ logo, productName, planName, description }: ProductInfoProps) {
  const defaultDescription = "Tinjau target dan realisasinya dari setiap aspek digitalisasi untuk menganalisa peningkatan kinerja.";
  
  return (
    <div className="flex-1">
      <h3 className="text-xl font-semibold mb-1">
        {productName} <span className="text-teal-600">{planName}</span>
      </h3>
      
      <div 
        className="text-gray-600 mb-3 text-sm" 
        dangerouslySetInnerHTML={renderHTML(description || defaultDescription)}
      />
    </div>
  );
}
